<p-floatLabel>
  <p-multiselect  #areaSelector
            id="areaSelector"
            name="areaSelector"
            [options]="areas"
            [(ngModel)]="selectedAreas"
            [showClear]="true"
            [filter]="true"
            [disabled]="isSubArea && isDisabled"
            styleClass="w-100"
            [selectedItemsLabel]="l('::SelectedItems', selectedAreas?.length)"
            (ngModelChange)="onSelected()"
            optionLabel="organizationUnitName">
    <ng-template let-option pTemplate="item">
      {{ option?.organizationUnitName }}
    </ng-template>
  </p-multiselect >
  <label for="areaSelector">
    <app-label-content [isRequired]="isRequired">
      {{ getLabel() }}
    </app-label-content>
  </label>
</p-floatLabel>
